import { render, staticRenderFns } from "./workpackage-pg-summary.vue?vue&type=template&id=f616c526&scoped=true"
import script from "./workpackage-pg-summary.vue?vue&type=script&lang=js"
export * from "./workpackage-pg-summary.vue?vue&type=script&lang=js"
import style0 from "./workpackage-pg-summary.vue?vue&type=style&index=0&id=f616c526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f616c526",
  null
  
)

export default component.exports